import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BaseErrorInterface, BaseMessageInterface, CoreOrchestratorViewModelInterface, ExternalModalViewModelInterface, MetaDataDescriptionsInterface, ModalContainerInterface, ModalResultInterface, ModalServiceInterface, ModalViewModelInterface, ShowExceptionPopUpFromBaseErrorInterface, ShowExceptionPopUpInterface, ShowMessageInterface, ShowPopUpModalInterface, ShowStandardModalInterface, ZoomOrchestratorViewModelInterface, ZoomResultInterface } from '@nts/std/interfaces';
import { ComponentType } from '@angular/cdk/overlay';
import { MessageButton, MessageResult } from '@nts/std/types';


export interface ShowCustomModalWithResulInterface<TResult> {
  viewModel: ModalViewModelInterface<any, TResult>,
  showCancel?: boolean,
  maximizable?: boolean,
  maximized?: boolean,
  config?: MatDialogConfig<any>,
}

export interface ShowExternalModalInterface<TResult> {
  baseUrl: string,
  jsonIdentity?: string | undefined,
  additionalQueryParams?: URLSearchParams,
  modalTitle?: string,
  externalReturn?: boolean,
  supportRemoteClosingCheck?: boolean,
  customExternalModalViewModel?: ExternalModalViewModelInterface<any, TResult> | undefined,
  supportRemoteStatus?: boolean,
  customModalContainerComponent?: ComponentType<ModalContainerInterface> | undefined;
  config?: MatDialogConfig<any> | undefined;
}

@Injectable()
export abstract class ModalService implements ModalServiceInterface {

  ovm: CoreOrchestratorViewModelInterface;
  route?: ActivatedRoute;

  abstract showStandardModalAsync(
    buttons: MessageButton | ShowStandardModalInterface,
    title?: string,
    viewModel?: ModalViewModelInterface<any, void>,
    config?: MatDialogConfig<any>,
    metaDataDescriptionsButtons?: MetaDataDescriptionsInterface[],
    customModalContainerComponent?: ComponentType<ModalContainerInterface>,
  ): Promise<MessageResult>;

  abstract showCustomModalWithResultAsync<TResult>(
    viewModel: ModalViewModelInterface<any, TResult> | ShowCustomModalWithResulInterface<TResult>,
    showCancel?: boolean,
    maximizable?: boolean,
    maximized?: boolean,
    config?: MatDialogConfig<any>,
    isCentered?: boolean
  ): Promise<ModalResultInterface<TResult>>;

  abstract showCustomModalWithResultAndCustomModalContainerAsync<TResult>(
    viewModel: ModalViewModelInterface<any, TResult> | ShowCustomModalWithResulInterface<TResult>,
    customModalConatinerComponent: ComponentType<ModalContainerInterface>,
    showCancel?: boolean,
    maximizable?: boolean,
    maximized?: boolean,
    config?: MatDialogConfig<any>,
  ): Promise<ModalResultInterface<TResult>>;

  abstract showExternalModal<TResult>(
    baseUrl: string | ShowExternalModalInterface<TResult>,
    jsonIdentity?: string | undefined,
    additionalQueryParams?: URLSearchParams,
    modalTitle?: string,
    externalReturn?: boolean,
    supportRemoteClosingCheck?: boolean,
    customExternalModalViewModel?: ExternalModalViewModelInterface<any, TResult> | undefined,
    supportRemoteStatus?: boolean,
    customModalContainerComponent?: ComponentType<ModalContainerInterface> | undefined,
    config?: MatDialogConfig<any> | undefined
  ): Promise<ModalResultInterface<TResult>>;

  abstract showZoomAsync(
    viewModel: ZoomOrchestratorViewModelInterface,
    maximizable?: boolean,
    panelClass?: string,
    width?: string
  ): Promise<ModalResultInterface<ZoomResultInterface>>

  abstract showMessageAsync(
    title: string | ShowMessageInterface,

    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    message?: string,

    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    buttons?: MessageButton,

    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    metaDataDescriptionsButtons?: MetaDataDescriptionsInterface[],

    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    panelClass?: string | undefined,
    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    width?: string | undefined,

    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    height?: string | undefined,

    /**
     * @deprecated Use the ShowMessageInterface parameter instead
     */
    top?: string | undefined
  ): Promise<MessageResult>;

  abstract showExceptionPopUp(
    error: Error | ShowExceptionPopUpInterface,
    caption?: string,
    message?: string,
    mmetaDataDescriptionsButton?: MetaDataDescriptionsInterface | undefined,
    panelClass?: string | undefined,
    width?: string | undefined
  ): Promise<MessageResult>;

  abstract showExceptionPopUpFromBaseErrors<TResult = any>(
    params: ShowExceptionPopUpFromBaseErrorInterface,
  ): Promise<ModalResultInterface<TResult>>;

  abstract showPopUp(
    informations: Array<BaseMessageInterface> | ShowPopUpModalInterface,
    errors?: Array<BaseErrorInterface>,
    caption?: string,
    metaDataDescriptionsButton?: MetaDataDescriptionsInterface | undefined,
    panelClass?: string | undefined,
    width?: string | undefined
  ): Promise<MessageResult>;

}
